import { DataStringComponent } from "./data-string-component.js";

export class DataNumberComponent extends DataStringComponent {
    static webComponentName: string = "data-number";
    protected inputType: string = "number"; 
    constructor() {
        super();
    }
    
}